(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[250],{

/***/ 86010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clsx */
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["Z"] = (clsx);

/***/ }),

/***/ 52624:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(41672)


/***/ }),

/***/ 41672:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var xtend = __webpack_require__(47529)
var defaults = __webpack_require__(29370)

module.exports = wrapper

var own = {}.hasOwnProperty
var push = [].push

var nodeSchema = {
  root: {children: all},
  doctype: handleDoctype,
  comment: handleComment,
  element: {
    tagName: handleTagName,
    properties: handleProperties,
    children: all
  },
  text: {value: handleValue},
  '*': {data: allow, position: allow}
}

// Sanitize `node`, according to `schema`.
function wrapper(node, schema) {
  var ctx = {type: 'root', children: []}
  var replace

  if (node && typeof node === 'object' && node.type) {
    replace = one(xtend(defaults, schema || {}), node, [])

    if (replace) {
      if ('length' in replace) {
        if (replace.length === 1) {
          ctx = replace[0]
        } else {
          ctx.children = replace
        }
      } else {
        ctx = replace
      }
    }
  }

  return ctx
}

// Sanitize `node`.
function one(schema, node, stack) {
  var type = node && node.type
  var replacement = {type: node.type}
  var replace
  var definition
  var allowed
  var result
  var key

  if (own.call(nodeSchema, type)) {
    definition = nodeSchema[type]

    if (typeof definition === 'function') {
      definition = definition(schema, node)
    }

    if (definition) {
      replace = true
      allowed = xtend(definition, nodeSchema['*'])

      for (key in allowed) {
        result = allowed[key](schema, node[key], node, stack)

        if (result === false) {
          replace = null
          // Set the non-safe value.
          replacement[key] = node[key]
        } else if (result != null) {
          replacement[key] = result
        }
      }
    }
  }

  if (replace) {
    return replacement
  }

  return replacement.children &&
    replacement.children.length &&
    schema.strip.indexOf(replacement.tagName) < 0
    ? replacement.children
    : null
}

// Sanitize `children`.
function all(schema, children, node, stack) {
  var results = []
  var index = -1
  var value

  if (children) {
    stack.push(node.tagName)

    while (++index < children.length) {
      value = one(schema, children[index], stack)

      if (value) {
        if ('length' in value) {
          push.apply(results, value)
        } else {
          results.push(value)
        }
      }
    }

    stack.pop()
  }

  return results
}

// Sanitize `properties`.
function handleProperties(schema, properties, node, stack) {
  var name = handleTagName(schema, node.tagName, node, stack)
  var reqs = schema.required || /* istanbul ignore next */ {}
  var props = properties || {}
  var allowed = xtend(
    toPropertyValueMap(schema.attributes['*']),
    toPropertyValueMap(
      own.call(schema.attributes, name) ? schema.attributes[name] : []
    )
  )
  var result = {}
  var definition
  var key
  var value

  for (key in props) {
    if (own.call(allowed, key)) {
      definition = allowed[key]
    } else if (data(key) && own.call(allowed, 'data*')) {
      definition = allowed['data*']
    } else {
      continue
    }

    value = props[key]
    value =
      value && typeof value === 'object' && 'length' in value
        ? handlePropertyValues(schema, value, key, definition)
        : handlePropertyValue(schema, value, key, definition)

    if (value != null) {
      result[key] = value
    }
  }

  if (own.call(reqs, name)) {
    for (key in reqs[name]) {
      if (!own.call(result, key)) {
        result[key] = reqs[name][key]
      }
    }
  }

  return result
}

// Sanitize a property value which is a list.
function handlePropertyValues(schema, values, prop, definition) {
  var result = []
  var index = -1
  var value

  while (++index < values.length) {
    value = handlePropertyValue(schema, values[index], prop, definition)

    if (value != null) {
      result.push(value)
    }
  }

  return result
}

// Sanitize a property value.
function handlePropertyValue(schema, value, prop, definition) {
  if (
    (typeof value === 'boolean' ||
      typeof value === 'number' ||
      typeof value === 'string') &&
    handleProtocol(schema, value, prop) &&
    (!definition.length || definition.indexOf(value) > -1)
  ) {
    return schema.clobber.indexOf(prop) < 0
      ? value
      : schema.clobberPrefix + value
  }
}

// Check whether `value` is a safe URL.
function handleProtocol(schema, value, prop) {
  var url = String(value)
  var colon = url.indexOf(':')
  var questionMark = url.indexOf('?')
  var numberSign = url.indexOf('#')
  var slash = url.indexOf('/')
  var protocols = own.call(schema.protocols, prop)
    ? schema.protocols[prop].concat()
    : []
  var index = -1

  if (
    !protocols.length ||
    colon < 0 ||
    // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    (slash > -1 && colon > slash) ||
    (questionMark > -1 && colon > questionMark) ||
    (numberSign > -1 && colon > numberSign)
  ) {
    return true
  }

  while (++index < protocols.length) {
    if (
      colon === protocols[index].length &&
      url.slice(0, protocols[index].length) === protocols[index]
    ) {
      return true
    }
  }

  return false
}

// Always return a valid HTML5 doctype.
function handleDoctypeName() {
  return 'html'
}

// Sanitize `tagName`.
function handleTagName(schema, tagName, node, stack) {
  var name = typeof tagName === 'string' && tagName
  var index = -1

  if (!name || name === '*' || schema.tagNames.indexOf(name) < 0) {
    return false
  }

  // Some nodes can break out of their context if they don’t have a certain
  // ancestor.
  if (own.call(schema.ancestors, name)) {
    while (++index < schema.ancestors[name].length) {
      if (stack.indexOf(schema.ancestors[name][index]) > -1) {
        return name
      }
    }

    return false
  }

  return name
}

function handleDoctype(schema) {
  return schema.allowDoctypes ? {name: handleDoctypeName} : null
}

function handleComment(schema) {
  return schema.allowComments ? {value: handleCommentValue} : null
}

// See <https://html.spec.whatwg.org/multipage/parsing.html#serialising-html-fragments>
function handleCommentValue(schema, value) {
  var result = typeof value === 'string' ? value : ''
  var index = result.indexOf('-->')

  return index < 0 ? result : result.slice(0, index)
}

// Sanitize `value`.
function handleValue(schema, value) {
  return typeof value === 'string' ? value : ''
}

// Create a map from a list of props or a list of properties and values.
function toPropertyValueMap(values) {
  var result = {}
  var index = -1
  var value

  while (++index < values.length) {
    value = values[index]

    if (value && typeof value === 'object' && 'length' in value) {
      result[value[0]] = value.slice(1)
    } else {
      result[value] = []
    }
  }

  return result
}

// Allow `value`.
function allow(schema, value) {
  return value
}

// Check if `prop` is a data property.
function data(prop) {
  return prop.length > 4 && prop.slice(0, 4).toLowerCase() === 'data'
}


/***/ }),

/***/ 22705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* reexport */ NewsletterWidget; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/yup/index.esm.js
var index_esm = __webpack_require__(16310);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(55678);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@ebay/nice-modal-react/lib/esm/index.js
var esm = __webpack_require__(25362);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/services/userService.js + 1 modules
var userService = __webpack_require__(24989);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
// EXTERNAL MODULE: ./store/actions/event.js
var actions_event = __webpack_require__(61748);
// EXTERNAL MODULE: ./components/styleguide/NewsletterWidget/newsletter-widget.module.scss
var newsletter_widget_module = __webpack_require__(504);
var newsletter_widget_module_default = /*#__PURE__*/__webpack_require__.n(newsletter_widget_module);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/TextInput/index.ts
var TextInput = __webpack_require__(32447);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var utilities_system = __webpack_require__(70591);
;// CONCATENATED MODULE: ./components/styleguide/NewsletterWidget/NewsletterWidget.tsx



















var Icon = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(1490)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var RecaptchaModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9418), __webpack_require__.e(193)]).then(__webpack_require__.bind(__webpack_require__, 193));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(193)
            ];
        }
    }
});
var NewsletterWidget = function(param) {
    var _isInline = param.isInline, isInline = _isInline === void 0 ? false : _isInline, _hasLargeTitle = param.hasLargeTitle, hasLargeTitle = _hasLargeTitle === void 0 ? false : _hasLargeTitle, location = param.location;
    var newsletterFormSchema = index_esm/* object */.Ry({
        newsletterEmail: index_esm/* string */.Z_().email("Please enter a valid email address").required("Your email address is required")
    });
    var ref = (0,react.useState)(constants/* constants.componentStatus.DEFAULT */._G.componentStatus.DEFAULT), subscribeStatus = ref[0], setSubscribeStatus = ref[1];
    var isDesktop = (0,react_responsive.useMediaQuery)({
        query: "(min-width: 992px)"
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var onSubmitForm = function(values) {
        esm/* default.show */.ZP.show(RecaptchaModal).then(function(value) {
            (0,userService/* sendNewsletterDetailsService */.gQ)({
                emailAddress: values.newsletterEmail,
                "g-recaptcha-response": value
            }).then(function(res) {
                if (res.error) {
                    setSubscribeStatus(constants/* constants.componentStatus.ERROR */._G.componentStatus.ERROR);
                } else {
                    setSubscribeStatus(constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE);
                    (0,react_toastify_esm/* toast */.Am)("Successfully signed up for newsletter");
                    (0,vehicle/* addToDataLayer */.Bk)({
                        event: "user-newsletter-signup",
                        label: location
                    });
                    dispatch((0,actions_event/* postAnalyticsEvent */.gR)({
                        event: constants/* constants.eventTypes.newsletterSignup */._G.eventTypes.newsletterSignup,
                        payload: {
                            formType: "widget",
                            emailAddressOnly: false
                        }
                    }));
                    if (typeof window.ttq !== "undefined") {
                        window.ttq.track("Subscribe", {
                            // eslint-disable-next-line camelcase
                            content_id: "Newsletter subscribe",
                            // eslint-disable-next-line camelcase
                            content_type: "product",
                            // eslint-disable-next-line camelcase
                            content_name: "Newsletter subscribe",
                            quantity: 1,
                            value: null,
                            price: null,
                            currency: "GBP"
                        });
                    }
                }
            }).catch(function(e) {
                (0,esm_exports/* captureException */.Tb)("Failed to sign up to newsletter", e);
                setSubscribeStatus(constants/* constants.componentStatus.ERROR */._G.componentStatus.ERROR);
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (newsletter_widget_module_default()).main,
        "data-is-inline": isInline,
        children: [
            hasLargeTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (newsletter_widget_module_default()).text,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    className: "".concat((newsletter_widget_module_default()).title, " ").concat((newsletter_widget_module_default()).large),
                    children: "Sign up for exclusive deals, Loco updates, latest news and more."
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (newsletter_widget_module_default()).text,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: (newsletter_widget_module_default()).title,
                        children: "Sign up for our newsletter"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (newsletter_widget_module_default()).paragraph,
                        children: "Get news, car tips & hottest offers"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (newsletter_widget_module_default())["form-wrapper"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                    validationSchema: newsletterFormSchema,
                    enableReinitialize: true,
                    validateOnChange: false,
                    validateOnBlur: false,
                    initialValues: {
                        newsletterEmail: ""
                    },
                    onSubmit: function(values) {
                        return onSubmitForm(values);
                    },
                    children: function(param) {
                        var handleSubmit = param.handleSubmit;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                            className: (newsletter_widget_module_default()).form,
                            onSubmit: handleSubmit,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                id: "newsletterEmail",
                                placeholder: "Enter your email".concat(isDesktop ? " address" : ""),
                                name: "email",
                                autoComplete: "email",
                                disabled: subscribeStatus === constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE,
                                button: {
                                    size: system/* Size.Medium */.$u.Medium,
                                    hierarchy: Button/* ButtonHierarchy.Filled */.B.Filled,
                                    theme: system/* Theme.light */.Q2.light,
                                    label: "Subscribe",
                                    type: "submit",
                                    className: !(0,utilities_system/* isProd */.BB)() ? "newsletter__subscribe-button" : ""
                                }
                            })
                        });
                    }
                })
            }),
            (subscribeStatus === constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE || subscribeStatus === constants/* constants.componentStatus.ERROR */._G.componentStatus.ERROR) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "data-state": subscribeStatus,
                className: (newsletter_widget_module_default()).notification,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        customClass: (newsletter_widget_module_default())["notification--icon"],
                        name: subscribeStatus === constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE ? "CheckCircle2" : "Info",
                        size: system/* Size.Medium */.$u.Medium
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (newsletter_widget_module_default())["notification--text"],
                        children: subscribeStatus === constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE ? "Great, you'll get the first email soon" : "We were unable to sign your email up. Please try again later."
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/NewsletterWidget/index.ts



/***/ }),

/***/ 77786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ TextInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80969);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82580);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96732);
/* harmony import */ var _text_input_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98547);
/* harmony import */ var _text_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_text_input_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _types_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16693);









var TextInput = function(param) {
    var label = param.label, hint = param.hint, id = param.id, placeholder = param.placeholder, button = param.button, disabled = param.disabled, visual = param.visual, type = param.type, required = param.required, inputMode = param.inputMode, pattern = param.pattern, _hideHintText = param.hideHintText, hideHintText = _hideHintText === void 0 ? false : _hideHintText, min = param.min, max = param.max, passwordrules = param.passwordrules, inputPrefixNode = param.inputPrefixNode, _className = param.className, className = _className === void 0 ? "" : _className, _classNameBox = param.classNameBox, classNameBox = _classNameBox === void 0 ? "" : _classNameBox, maxLength = param.maxLength;
    var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,formik__WEBPACK_IMPORTED_MODULE_5__/* .useField */ .U$)({
        name: id
    }), 2), field = ref[0], meta = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_text_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().main), " ").concat(className),
        "data-visual": visual,
        "data-input-type": type,
        "data-disabled": disabled || visual === true,
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                htmlFor: id,
                className: (_text_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label),
                children: [
                    label,
                    required && "*"
                ]
            }),
            inputPrefixNode,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "input-box ".concat((_text_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().box), " ").concat(button && button.label ? (_text_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["with-button"]) : "", " ").concat(classNameBox),
                "data-error": !!meta.error,
                onClick: function() {
                    var ref;
                    return (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                        id: id,
                        className: (_text_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().input),
                        placeholder: placeholder,
                        disabled: disabled || visual === true,
                        ref: inputRef,
                        type: type,
                        inputMode: inputMode,
                        pattern: pattern
                    }, field), {
                        min: min,
                        max: max,
                        maxLength: maxLength,
                        passwordrules: passwordrules
                    })),
                    button && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, button), {
                        hierarchy: _Button__WEBPACK_IMPORTED_MODULE_2__/* .ButtonHierarchy.Filled */ .B.Filled,
                        disabled: disabled,
                        theme: button.theme ? button.theme : _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Theme.dark */ .Q2.dark
                    }))
                ]
            }),
            !hideHintText && (hint || meta.error) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_text_input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().foot),
                "data-error": !!meta.error,
                children: meta.error || hint
            })
        ]
    });
};


/***/ }),

/***/ 32447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* reexport safe */ _TextInput__WEBPACK_IMPORTED_MODULE_0__.o; }
/* harmony export */ });
/* harmony import */ var _TextInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77786);



/***/ }),

/***/ 60250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ContentPageBody; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/timezone.js
var timezone = __webpack_require__(29387);
var timezone_default = /*#__PURE__*/__webpack_require__.n(timezone);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/utc.js
var utc = __webpack_require__(70178);
var utc_default = /*#__PURE__*/__webpack_require__.n(utc);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-markdown/src/react-markdown.js
var react_markdown = __webpack_require__(38456);
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);
// EXTERNAL MODULE: ./node_modules/rehype-raw/index.js
var rehype_raw = __webpack_require__(76388);
var rehype_raw_default = /*#__PURE__*/__webpack_require__.n(rehype_raw);
// EXTERNAL MODULE: ./node_modules/rehype-sanitize/index.js
var rehype_sanitize = __webpack_require__(1667);
var rehype_sanitize_default = /*#__PURE__*/__webpack_require__.n(rehype_sanitize);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
;// CONCATENATED MODULE: ./lib/utilities/content.ts
var getAverageReadTime = function(numberOfWords) {
    var averageWordsPerMinute = 225;
    return Math.ceil(numberOfWords / averageWordsPerMinute);
};

// EXTERNAL MODULE: ./components/styleguide/NewsletterWidget/index.ts + 1 modules
var NewsletterWidget = __webpack_require__(22705);
// EXTERNAL MODULE: ./components/views/ContentPageBody/content-page-body.module.scss
var content_page_body_module = __webpack_require__(17188);
var content_page_body_module_default = /*#__PURE__*/__webpack_require__.n(content_page_body_module);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/Link/index.ts + 1 modules
var Link = __webpack_require__(63383);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/views/ContentPageBody/ContentPageBody.js


















var ContentPageBody = function(param) {
    var article = param.article;
    dayjs_min_default().extend((utc_default()));
    dayjs_min_default().extend((timezone_default()));
    var customSanitize = (0,react.useMemo)(function() {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (rehype_sanitize_default())), {
            tagNames: [
                "div",
                "p",
                "a",
                "h1",
                "h2",
                "h3",
                "ul",
                "li"
            ],
            attributes: {
                "*": [
                    "class",
                    "id",
                    "href"
                ],
                a: [
                    "target",
                    "rel"
                ],
                div: [
                    "class"
                ]
            }
        });
    }, []);
    var flattenImages = function(children) {
        if (children && children[0] && children.length === 1 && children[0].props && children[0].props.src) {
            var ref = children[0], imgEl = ref.props;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (content_page_body_module_default()).image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: imgEl.src,
                    alt: imgEl.alt,
                    width: 1320,
                    height: 742
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "".concat((content_page_body_module_default()).content, " ").concat((content_page_body_module_default()).paragraph),
            children: children
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((content_page_body_module_default()).content, " ").concat((content_page_body_module_default()).header),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (content_page_body_module_default()).title,
                        children: article.content.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: (content_page_body_module_default()).meta,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "".concat((content_page_body_module_default()).item, " ").concat((content_page_body_module_default()).author),
                                children: [
                                    "By ",
                                    article.content.author
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "".concat((content_page_body_module_default()).item, " ").concat((content_page_body_module_default()).ellipse)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: (content_page_body_module_default()).item,
                                children: [
                                    getAverageReadTime(article.content.body.toString().split(" ").length),
                                    " min read"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "".concat((content_page_body_module_default()).item, " ").concat((content_page_body_module_default()).ellipse)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: (content_page_body_module_default()).item,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                    dateTime: dayjs_min_default()(article.content.pubDate).tz("Europe/London").format(),
                                    children: dayjs_min_default()(article.content.pubDate).tz("Europe/London").format(constants/* constants.blogDateFormat */._G.blogDateFormat)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterWidget/* NewsletterWidget */.X, {
                        location: "blog"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "".concat((content_page_body_module_default()).description, " ").concat((content_page_body_module_default()).paragraph),
                        children: article.content.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (content_page_body_module_default()).image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: article.content.thumbnail,
                    alt: article.content.thumbnailAlt,
                    width: 1320,
                    height: 742.5
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                className: (content_page_body_module_default()).article,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_markdown_default()), {
                    components: {
                        p: function p(param) {
                            var children = param.children;
                            return flattenImages(children);
                        },
                        br: function br() {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) // removes break tags
                            ;
                        },
                        h1: function h1() {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) // removes duplicate h1s
                            ;
                        },
                        h2: function h2(param) {
                            var children = param.children;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: (content_page_body_module_default()).h2,
                                children: children
                            });
                        },
                        h3: function h3(param) {
                            var children = param.children;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (content_page_body_module_default()).h3,
                                children: children
                            });
                        },
                        h4: function h4(param) {
                            var children = param.children;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (content_page_body_module_default()).h4,
                                children: children
                            });
                        },
                        ul: function ul(param) {
                            var children = param.children;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: (content_page_body_module_default())["unordered-list"],
                                children: children
                            });
                        },
                        a: function a(param) {
                            var href = param.href, children = param.children;
                            var text = Array.isArray(children) ? children[0] : children;
                            var targetAttr = "";
                            var classAttr = "";
                            var attributeMatch = text.match(/{:.*?}/);
                            if (attributeMatch) {
                                var attributes = attributeMatch[0].replace(/{:|}/g, "").trim().replace(/&quot;/g, '"');
                                var targetMatch = attributes.match(/target="([^"]+)"/);
                                if (targetMatch) {
                                    targetAttr = targetMatch[1];
                                }
                                var classMatch = attributes.match(/class="([^"]+)"/);
                                if (classMatch) {
                                    classAttr = classMatch[1];
                                }
                                text = text.replace(attributeMatch[0], "").trim();
                            }
                            if (classAttr === "button") {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                                    size: system/* Size.Large */.$u.Large,
                                    hierarchy: Button/* ButtonHierarchy.Filled */.B.Filled,
                                    href: href,
                                    hasPadding: true,
                                    hasBackground: true,
                                    target: targetAttr || undefined,
                                    className: (content_page_body_module_default())[classAttr],
                                    children: text
                                });
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: href,
                                target: targetAttr || undefined,
                                className: (content_page_body_module_default())[classAttr] || undefined,
                                children: text
                            });
                        }
                    },
                    rehypePlugins: [
                        (rehype_raw_default()),
                        customSanitize
                    ],
                    children: article.content.body.replace(/:::cta/g, '<div class="'.concat((content_page_body_module_default())["cta-block"], '">')).replace(/:::/g, "</div>")
                })
            }),
            !article && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "alert alert-warning mt-3",
                role: "alert",
                children: "We've had trouble finding this blog post. Please try again later."
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/views/ContentPageBody/index.js



/***/ }),

/***/ 504:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"newsletter-widget_main__oKvzs","form-wrapper":"newsletter-widget_form-wrapper__BzOO4","notification":"newsletter-widget_notification__EQFD0","notification--icon":"newsletter-widget_notification--icon__goNyl","form":"newsletter-widget_form__xg4Px","title":"newsletter-widget_title__a_kqZ","large":"newsletter-widget_large__0DvdK","paragraph":"newsletter-widget_paragraph__qgSNK","phAnimation":"newsletter-widget_phAnimation__m6z4t"};

/***/ }),

/***/ 98547:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"text-input_main__mXMTo","box":"text-input_box__Wtjs_","input":"text-input_input__t__VH","label":"text-input_label__1LsbV","foot":"text-input_foot__gko_I","with-button":"text-input_with-button__Lh6hs","validation":"text-input_validation__32H_P","tests":"text-input_tests__XEYhx","test":"text-input_test__e87uJ","icon-default":"text-input_icon-default__oVY_r","icon-fail":"text-input_icon-fail__YHJNr","icon-pass":"text-input_icon-pass__25gAD","password":"text-input_password__N8xxl","phAnimation":"text-input_phAnimation__zUNac"};

/***/ }),

/***/ 17188:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"unordered-list":"content-page-body_unordered-list__KAqgH","content":"content-page-body_content__1clwf","h2":"content-page-body_h2__UTuDK","h3":"content-page-body_h3__hIOxQ","h4":"content-page-body_h4__W3yRg","cta-block":"content-page-body_cta-block__teM27","header":"content-page-body_header__6bzpI","title":"content-page-body_title__ouJiU","paragraph":"content-page-body_paragraph__wPS1w","button":"content-page-body_button__ugRPf","article":"content-page-body_article__ws_9L","meta":"content-page-body_meta__vqfgi","item":"content-page-body_item__oTC_x","ellipse":"content-page-body_ellipse__0NwRU","author":"content-page-body_author__XorJV","image":"content-page-body_image__8pGk3","phAnimation":"content-page-body_phAnimation__d_AMI"};

/***/ }),

/***/ 1667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var clean = __webpack_require__(52624)

module.exports = sanitize

function sanitize(options) {
  return transformer
  function transformer(tree) {
    return clean(tree, options)
  }
}


/***/ }),

/***/ 55678:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Am": function() { return /* binding */ Q; },
/* harmony export */   "Ix": function() { return /* binding */ k; }
/* harmony export */ });
/* unused harmony exports Bounce, Flip, Icons, Slide, Zoom, collapseToast, cssTransition, useToast, useToastContainer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86010);
'use client';
const u=t=>"number"==typeof t&&!isNaN(t),d=t=>"string"==typeof t,p=t=>"function"==typeof t,m=t=>d(t)||p(t)?t:null,f=t=>(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(t)||d(t)||p(t)||u(t);function g(t,e,n){void 0===n&&(n=300);const{scrollHeight:o,style:s}=t;requestAnimationFrame(()=>{s.minHeight="initial",s.height=o+"px",s.transition=`all ${n}ms`,requestAnimationFrame(()=>{s.height="0",s.padding="0",s.margin="0",setTimeout(e,n)})})}function h(e){let{enter:a,exit:r,appendPosition:i=!1,collapse:l=!0,collapseDuration:c=300}=e;return function(e){let{children:u,position:d,preventExitTransition:p,done:m,nodeRef:f,isIn:h}=e;const y=i?`${a}--${d}`:a,v=i?`${r}--${d}`:r,T=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);return (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(()=>{const t=f.current,e=y.split(" "),n=o=>{o.target===f.current&&(t.dispatchEvent(new Event("d")),t.removeEventListener("animationend",n),t.removeEventListener("animationcancel",n),0===T.current&&"animationcancel"!==o.type&&t.classList.remove(...e))};t.classList.add(...e),t.addEventListener("animationend",n),t.addEventListener("animationcancel",n)},[]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{const t=f.current,e=()=>{t.removeEventListener("animationend",e),l?g(t,m,c):m()};h||(p?e():(T.current=1,t.className+=` ${v}`,t.addEventListener("animationend",e)))},[h]),react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,u)}}function y(t,e){return null!=t?{content:t.content,containerId:t.props.containerId,id:t.props.toastId,theme:t.props.theme,type:t.props.type,data:t.props.data||{},isLoading:t.props.isLoading,icon:t.props.icon,status:e}:{}}const v={list:new Map,emitQueue:new Map,on(t,e){return this.list.has(t)||this.list.set(t,[]),this.list.get(t).push(e),this},off(t,e){if(e){const n=this.list.get(t).filter(t=>t!==e);return this.list.set(t,n),this}return this.list.delete(t),this},cancelEmit(t){const e=this.emitQueue.get(t);return e&&(e.forEach(clearTimeout),this.emitQueue.delete(t)),this},emit(t){this.list.has(t)&&this.list.get(t).forEach(e=>{const n=setTimeout(()=>{e(...[].slice.call(arguments,1))},0);this.emitQueue.has(t)||this.emitQueue.set(t,[]),this.emitQueue.get(t).push(n)})}},T=e=>{let{theme:n,type:o,...s}=e;return react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",{viewBox:"0 0 24 24",width:"100%",height:"100%",fill:"colored"===n?"currentColor":`var(--toastify-icon-color-${o})`,...s})},E={info:function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(T,{...e},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{d:"M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"}))},warning:function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(T,{...e},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{d:"M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"}))},success:function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(T,{...e},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{d:"M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"}))},error:function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(T,{...e},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{d:"M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"}))},spinner:function(){return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"Toastify__spinner"})}};function C(t){const[,o]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(t=>t+1,0),[l,c]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),g=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),h=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new Map).current,T=t=>-1!==l.indexOf(t),C=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({toastKey:1,displayedToast:0,count:0,queue:[],props:t,containerId:null,isToastActive:T,getToast:t=>h.get(t)}).current;function b(t){let{containerId:e}=t;const{limit:n}=C.props;!n||e&&C.containerId!==e||(C.count-=C.queue.length,C.queue=[])}function I(t){c(e=>null==t?[]:e.filter(e=>e!==t))}function _(){const{toastContent:t,toastProps:e,staleId:n}=C.queue.shift();O(t,e,n)}function L(t,n){let{delay:s,staleId:r,...i}=n;if(!f(t)||function(t){return!g.current||C.props.enableMultiContainer&&t.containerId!==C.props.containerId||h.has(t.toastId)&&null==t.updateId}(i))return;const{toastId:l,updateId:c,data:T}=i,{props:b}=C,L=()=>I(l),N=null==c;N&&C.count++;const M={...b,style:b.toastStyle,key:C.toastKey++,...Object.fromEntries(Object.entries(i).filter(t=>{let[e,n]=t;return null!=n})),toastId:l,updateId:c,data:T,closeToast:L,isIn:!1,className:m(i.className||b.toastClassName),bodyClassName:m(i.bodyClassName||b.bodyClassName),progressClassName:m(i.progressClassName||b.progressClassName),autoClose:!i.isLoading&&(R=i.autoClose,w=b.autoClose,!1===R||u(R)&&R>0?R:w),deleteToast(){const t=y(h.get(l),"removed");h.delete(l),v.emit(4,t);const e=C.queue.length;if(C.count=null==l?C.count-C.displayedToast:C.count-1,C.count<0&&(C.count=0),e>0){const t=null==l?C.props.limit:1;if(1===e||1===t)C.displayedToast++,_();else{const n=t>e?e:t;C.displayedToast=n;for(let t=0;t<n;t++)_()}}else o()}};var R,w;M.iconOut=function(t){let{theme:n,type:o,isLoading:s,icon:r}=t,i=null;const l={theme:n,type:o};return!1===r||(p(r)?i=r(l):(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(r)?i=(0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(r,l):d(r)||u(r)?i=r:s?i=E.spinner():(t=>t in E)(o)&&(i=E[o](l))),i}(M),p(i.onOpen)&&(M.onOpen=i.onOpen),p(i.onClose)&&(M.onClose=i.onClose),M.closeButton=b.closeButton,!1===i.closeButton||f(i.closeButton)?M.closeButton=i.closeButton:!0===i.closeButton&&(M.closeButton=!f(b.closeButton)||b.closeButton);let x=t;(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(t)&&!d(t.type)?x=(0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(t,{closeToast:L,toastProps:M,data:T}):p(t)&&(x=t({closeToast:L,toastProps:M,data:T})),b.limit&&b.limit>0&&C.count>b.limit&&N?C.queue.push({toastContent:x,toastProps:M,staleId:r}):u(s)?setTimeout(()=>{O(x,M,r)},s):O(x,M,r)}function O(t,e,n){const{toastId:o}=e;n&&h.delete(n);const s={content:t,props:e};h.set(o,s),c(t=>[...t,o].filter(t=>t!==n)),v.emit(4,y(s,null==s.props.updateId?"added":"updated"))}return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>(C.containerId=t.containerId,v.cancelEmit(3).on(0,L).on(1,t=>g.current&&I(t)).on(5,b).emit(2,C),()=>{h.clear(),v.emit(3,C)}),[]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{C.props=t,C.isToastActive=T,C.displayedToast=l.length}),{getToastToRender:function(e){const n=new Map,o=Array.from(h.values());return t.newestOnTop&&o.reverse(),o.forEach(t=>{const{position:e}=t.props;n.has(e)||n.set(e,[]),n.get(e).push(t)}),Array.from(n,t=>e(t[0],t[1]))},containerRef:g,isToastActive:T}}function b(t){return t.targetTouches&&t.targetTouches.length>=1?t.targetTouches[0].clientX:t.clientX}function I(t){return t.targetTouches&&t.targetTouches.length>=1?t.targetTouches[0].clientY:t.clientY}function _(t){const[o,a]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1),[r,l]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1),c=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),u=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({start:0,x:0,y:0,delta:0,removalDistance:0,canCloseOnClick:!0,canDrag:!1,boundingRect:null,didMove:!1}).current,d=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t),{autoClose:m,pauseOnHover:f,closeToast:g,onClick:h,closeOnClick:y}=t;function v(e){if(t.draggable){"touchstart"===e.nativeEvent.type&&e.nativeEvent.preventDefault(),u.didMove=!1,document.addEventListener("mousemove",_),document.addEventListener("mouseup",L),document.addEventListener("touchmove",_),document.addEventListener("touchend",L);const n=c.current;u.canCloseOnClick=!0,u.canDrag=!0,u.boundingRect=n.getBoundingClientRect(),n.style.transition="",u.x=b(e.nativeEvent),u.y=I(e.nativeEvent),"x"===t.draggableDirection?(u.start=u.x,u.removalDistance=n.offsetWidth*(t.draggablePercent/100)):(u.start=u.y,u.removalDistance=n.offsetHeight*(80===t.draggablePercent?1.5*t.draggablePercent:t.draggablePercent/100))}}function T(e){if(u.boundingRect){const{top:n,bottom:o,left:s,right:a}=u.boundingRect;"touchend"!==e.nativeEvent.type&&t.pauseOnHover&&u.x>=s&&u.x<=a&&u.y>=n&&u.y<=o?C():E()}}function E(){a(!0)}function C(){a(!1)}function _(e){const n=c.current;u.canDrag&&n&&(u.didMove=!0,o&&C(),u.x=b(e),u.y=I(e),u.delta="x"===t.draggableDirection?u.x-u.start:u.y-u.start,u.start!==u.x&&(u.canCloseOnClick=!1),n.style.transform=`translate${t.draggableDirection}(${u.delta}px)`,n.style.opacity=""+(1-Math.abs(u.delta/u.removalDistance)))}function L(){document.removeEventListener("mousemove",_),document.removeEventListener("mouseup",L),document.removeEventListener("touchmove",_),document.removeEventListener("touchend",L);const e=c.current;if(u.canDrag&&u.didMove&&e){if(u.canDrag=!1,Math.abs(u.delta)>u.removalDistance)return l(!0),void t.closeToast();e.style.transition="transform 0.2s, opacity 0.2s",e.style.transform=`translate${t.draggableDirection}(0)`,e.style.opacity="1"}}(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{d.current=t}),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>(c.current&&c.current.addEventListener("d",E,{once:!0}),p(t.onOpen)&&t.onOpen((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(t.children)&&t.children.props),()=>{const t=d.current;p(t.onClose)&&t.onClose((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(t.children)&&t.children.props)}),[]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>(t.pauseOnFocusLoss&&(document.hasFocus()||C(),window.addEventListener("focus",E),window.addEventListener("blur",C)),()=>{t.pauseOnFocusLoss&&(window.removeEventListener("focus",E),window.removeEventListener("blur",C))}),[t.pauseOnFocusLoss]);const O={onMouseDown:v,onTouchStart:v,onMouseUp:T,onTouchEnd:T};return m&&f&&(O.onMouseEnter=C,O.onMouseLeave=E),y&&(O.onClick=t=>{h&&h(t),u.canCloseOnClick&&g()}),{playToast:E,pauseToast:C,isRunning:o,preventExitTransition:r,toastRef:c,eventHandlers:O}}function L(e){let{closeToast:n,theme:o,ariaLabel:s="close"}=e;return react__WEBPACK_IMPORTED_MODULE_0__.createElement("button",{className:`Toastify__close-button Toastify__close-button--${o}`,type:"button",onClick:t=>{t.stopPropagation(),n(t)},"aria-label":s},react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",{"aria-hidden":"true",viewBox:"0 0 14 16"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{fillRule:"evenodd",d:"M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"})))}function O(e){let{delay:n,isRunning:o,closeToast:s,type:a="default",hide:r,className:i,style:l,controlledProgress:u,progress:d,rtl:m,isIn:f,theme:g}=e;const h=r||u&&0===d,y={...l,animationDuration:`${n}ms`,animationPlayState:o?"running":"paused",opacity:h?0:1};u&&(y.transform=`scaleX(${d})`);const v=(0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("Toastify__progress-bar",u?"Toastify__progress-bar--controlled":"Toastify__progress-bar--animated",`Toastify__progress-bar-theme--${g}`,`Toastify__progress-bar--${a}`,{"Toastify__progress-bar--rtl":m}),T=p(i)?i({rtl:m,type:a,defaultClassName:v}):(0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(v,i);return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{role:"progressbar","aria-hidden":h?"true":"false","aria-label":"notification timer",className:T,style:y,[u&&d>=1?"onTransitionEnd":"onAnimationEnd"]:u&&d<1?null:()=>{f&&s()}})}const N=n=>{const{isRunning:o,preventExitTransition:s,toastRef:r,eventHandlers:i}=_(n),{closeButton:l,children:u,autoClose:d,onClick:m,type:f,hideProgressBar:g,closeToast:h,transition:y,position:v,className:T,style:E,bodyClassName:C,bodyStyle:b,progressClassName:I,progressStyle:N,updateId:M,role:R,progress:w,rtl:x,toastId:$,deleteToast:k,isIn:P,isLoading:B,iconOut:D,closeOnClick:A,theme:z}=n,F=(0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("Toastify__toast",`Toastify__toast-theme--${z}`,`Toastify__toast--${f}`,{"Toastify__toast--rtl":x},{"Toastify__toast--close-on-click":A}),H=p(T)?T({rtl:x,position:v,type:f,defaultClassName:F}):(0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(F,T),S=!!w||!d,q={closeToast:h,type:f,theme:z};let Q=null;return!1===l||(Q=p(l)?l(q):(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(l)?(0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(l,q):L(q)),react__WEBPACK_IMPORTED_MODULE_0__.createElement(y,{isIn:P,done:k,position:v,preventExitTransition:s,nodeRef:r},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{id:$,onClick:m,className:H,...i,style:E,ref:r},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{...P&&{role:R},className:p(C)?C({type:f}):(0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("Toastify__toast-body",C),style:b},null!=D&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:(0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("Toastify__toast-icon",{"Toastify--animate-icon Toastify__zoom-enter":!B})},D),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",null,u)),Q,react__WEBPACK_IMPORTED_MODULE_0__.createElement(O,{...M&&!S?{key:`pb-${M}`}:{},rtl:x,theme:z,delay:d,isRunning:o,isIn:P,closeToast:h,hide:g,type:f,style:N,className:I,controlledProgress:S,progress:w||0})))},M=function(t,e){return void 0===e&&(e=!1),{enter:`Toastify--animate Toastify__${t}-enter`,exit:`Toastify--animate Toastify__${t}-exit`,appendPosition:e}},R=h(M("bounce",!0)),w=h(M("slide",!0)),x=h(M("zoom")),$=h(M("flip")),k=(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((e,n)=>{const{getToastToRender:o,containerRef:a,isToastActive:r}=C(e),{className:i,style:l,rtl:u,containerId:d}=e;function f(t){const e=(0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("Toastify__toast-container",`Toastify__toast-container--${t}`,{"Toastify__toast-container--rtl":u});return p(i)?i({position:t,rtl:u,defaultClassName:e}):(0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(e,m(i))}return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{n&&(n.current=a.current)},[]),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{ref:a,className:"Toastify",id:d},o((e,n)=>{const o=n.length?{...l}:{...l,pointerEvents:"none"};return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:f(e),style:o,key:`container-${e}`},n.map((e,o)=>{let{content:s,props:a}=e;return react__WEBPACK_IMPORTED_MODULE_0__.createElement(N,{...a,isIn:r(a.toastId),style:{...a.style,"--nth":o+1,"--len":n.length},key:`toast-${a.key}`},s)}))}))});k.displayName="ToastContainer",k.defaultProps={position:"top-right",transition:R,autoClose:5e3,closeButton:L,pauseOnHover:!0,pauseOnFocusLoss:!0,closeOnClick:!0,draggable:!0,draggablePercent:80,draggableDirection:"x",role:"alert",theme:"light"};let P,B=new Map,D=[],A=1;function z(){return""+A++}function F(t){return t&&(d(t.toastId)||u(t.toastId))?t.toastId:z()}function H(t,e){return B.size>0?v.emit(0,t,e):D.push({content:t,options:e}),e.toastId}function S(t,e){return{...e,type:e&&e.type||t,toastId:F(e)}}function q(t){return(e,n)=>H(e,S(t,n))}function Q(t,e){return H(t,S("default",e))}Q.loading=(t,e)=>H(t,S("default",{isLoading:!0,autoClose:!1,closeOnClick:!1,closeButton:!1,draggable:!1,...e})),Q.promise=function(t,e,n){let o,{pending:s,error:a,success:r}=e;s&&(o=d(s)?Q.loading(s,n):Q.loading(s.render,{...n,...s}));const i={isLoading:null,autoClose:null,closeOnClick:null,closeButton:null,draggable:null},l=(t,e,s)=>{if(null==e)return void Q.dismiss(o);const a={type:t,...i,...n,data:s},r=d(e)?{render:e}:e;return o?Q.update(o,{...a,...r}):Q(r.render,{...a,...r}),s},c=p(t)?t():t;return c.then(t=>l("success",r,t)).catch(t=>l("error",a,t)),c},Q.success=q("success"),Q.info=q("info"),Q.error=q("error"),Q.warning=q("warning"),Q.warn=Q.warning,Q.dark=(t,e)=>H(t,S("default",{theme:"dark",...e})),Q.dismiss=t=>{B.size>0?v.emit(1,t):D=D.filter(e=>null!=t&&e.options.toastId!==t)},Q.clearWaitingQueue=function(t){return void 0===t&&(t={}),v.emit(5,t)},Q.isActive=t=>{let e=!1;return B.forEach(n=>{n.isToastActive&&n.isToastActive(t)&&(e=!0)}),e},Q.update=function(t,e){void 0===e&&(e={}),setTimeout(()=>{const n=function(t,e){let{containerId:n}=e;const o=B.get(n||P);return o&&o.getToast(t)}(t,e);if(n){const{props:o,content:s}=n,a={delay:100,...o,...e,toastId:e.toastId||t,updateId:z()};a.toastId!==t&&(a.staleId=t);const r=a.render||s;delete a.render,H(r,a)}},0)},Q.done=t=>{Q.update(t,{progress:1})},Q.onChange=t=>(v.on(4,t),()=>{v.off(4,t)}),Q.POSITION={TOP_LEFT:"top-left",TOP_RIGHT:"top-right",TOP_CENTER:"top-center",BOTTOM_LEFT:"bottom-left",BOTTOM_RIGHT:"bottom-right",BOTTOM_CENTER:"bottom-center"},Q.TYPE={INFO:"info",SUCCESS:"success",WARNING:"warning",ERROR:"error",DEFAULT:"default"},v.on(2,t=>{P=t.containerId||t,B.set(P,t),D.forEach(t=>{v.emit(0,t.content,t.options)}),D=[]}).on(3,t=>{B.delete(t.containerId||t),0===B.size&&v.off(0).off(1).off(5)});
//# sourceMappingURL=react-toastify.esm.mjs.map


/***/ }),

/***/ 29370:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"strip":["script"],"clobberPrefix":"user-content-","clobber":["name","id"],"ancestors":{"tbody":["table"],"tfoot":["table"],"thead":["table"],"td":["table"],"th":["table"],"tr":["table"]},"protocols":{"href":["http","https","mailto","xmpp","irc","ircs"],"cite":["http","https"],"src":["http","https"],"longDesc":["http","https"]},"tagNames":["h1","h2","h3","h4","h5","h6","br","b","i","strong","em","a","pre","code","img","tt","div","ins","del","sup","sub","p","ol","ul","table","thead","tbody","tfoot","blockquote","dl","dt","dd","kbd","q","samp","var","hr","ruby","rt","rp","li","tr","td","th","s","strike","summary","details","caption","figure","figcaption","abbr","bdo","cite","dfn","mark","small","span","time","wbr","input"],"attributes":{"a":["href"],"img":["src","longDesc"],"input":[["type","checkbox"],["disabled",true]],"li":[["className","task-list-item"]],"div":["itemScope","itemType"],"blockquote":["cite"],"del":["cite"],"ins":["cite"],"q":["cite"],"*":["abbr","accept","acceptCharset","accessKey","action","align","alt","ariaDescribedBy","ariaHidden","ariaLabel","ariaLabelledBy","axis","border","cellPadding","cellSpacing","char","charOff","charSet","checked","clear","cols","colSpan","color","compact","coords","dateTime","dir","disabled","encType","htmlFor","frame","headers","height","hrefLang","hSpace","isMap","id","label","lang","maxLength","media","method","multiple","name","noHref","noShade","noWrap","open","prompt","readOnly","rel","rev","rows","rowSpan","rules","scope","selected","shape","size","span","start","summary","tabIndex","target","title","type","useMap","vAlign","value","vSpace","width","itemProp"]},"required":{"input":{"type":"checkbox","disabled":true}}}');

/***/ })

}]);